const e = "typography", E = {
  0: "size-0",
  1: "size-1",
  2: "size-2",
  3: "size-3",
  4: "size-4",
  5: "size-5",
  N1: "size-n1",
  N2: "size-n2",
  N3: "size-n3"
}, T = {
  REGULAR: "regular",
  SEMIBOLD: "semibold",
  BOLD: "bold"
}, s = {
  P: "p",
  SPAN: "span",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
}, R = {
  UPPERCASE: "uppercase",
  LOWERCASE: "lowercase",
  CAPITALIZE: "capitalize",
  NONE: "none"
}, n = {
  START: "start",
  END: "end",
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center",
  JUSTIFY: "justify",
  JUSTIFY_ALL: "justify-all"
}, A = {
  UNDERLINE: "underline",
  OVERLINE: "overline",
  LINE_THROUGH: "line-through",
  NONE: "none"
};
export {
  e as TYPOGRAPHY_BASE_CLASS,
  s as TYPOGRAPHY_RENDER_AS,
  E as TYPOGRAPHY_SIZES,
  n as TYPOGRAPHY_TEXT_ALIGN,
  A as TYPOGRAPHY_TEXT_DECORATION,
  R as TYPOGRAPHY_TEXT_TRANSFORM,
  T as TYPOGRAPHY_WEIGHTS
};
